import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import * as ProjectActions from './senAppProjects.action';
import { ManageProjectsAbsService } from "../projects/manage-projects/manage-projects-abs.service";


@Injectable()
export class projectsEffects {

    loadProjects$ = createEffect(() => this.actions$.pipe(
        ofType(ProjectActions.loadProjects),
        map(action => action),
        mergeMap(action => this.MPService.getAllProjects(action)
            .pipe(
                map((projects: any) => ProjectActions.loadProjectsSuccess({ projects })),
                catchError(() => EMPTY)
            ))
    ));

    selectedProject$ = createEffect(() => this.actions$.pipe(
        ofType(ProjectActions.selectProject),
        map(action => action),
        mergeMap(action => this.MPService.getProject(action)
            .pipe(
                map((selectedProject: any) => ProjectActions.selectProjectSuccess({ selectedProject })),
                catchError(() => EMPTY)
            ))
    ));

    constructor(
        private actions$: Actions,
        private MPService: ManageProjectsAbsService
    ) { }
}